import { store } from "../store";
import { call, put, takeLatest } from "redux-saga/effects";
import ENV from "../config/env";
import axiosInstance from "../../api/axiosInstance";
import {
  GET_CANDIDATE_RECOMMENDED_REQUEST,
  SAVE_CANDIDATE_JOB_APPLICATION_STATUS_REQUEST,
  SAVE_CANDIDATE_REJECT_STATUS_REQUEST,
  SAVE_IGNORE_CANDIDATE_FROM_RECOMMENDATION_REQUEST,
  SCHEDULE_CANDIDATE_INTERVIEW_REQUEST,
} from "./CandidateManagement.type";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* candidateRecommendedTabSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/listing/Candidates?isRecommendedTab=True`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* candidateJobApplicationStatusSaga(action) {
  const {
    payload: { user, tabStatus, jobId },
    callback,
  } = action;

  try {
    const jobIdParam = jobId ? `&jobDetailsId=${jobId}` : "";
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/update/CandidateJobApplicationStatus?candidateId=${user}&candidateJobApplicationStatus=${tabStatus}${jobIdParam}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* candidateJobRejectedSaga(action) {
  const {
    payload: { user, tabStatus, rejectReason },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/update/CandidateJobApplicationStatus?candidateId=${user}&candidateJobApplicationStatus=${tabStatus}&rejectReason=${rejectReason}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveCandidateIgnoreSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/ignore/CandidateAgainstTheJob`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* scheduleCandidateInterviewSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/save/CandidateInterviewSchedule`,
      payload,
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* candidateManagementWatcherSaga() {
  yield takeLatest(
    GET_CANDIDATE_RECOMMENDED_REQUEST,
    candidateRecommendedTabSaga,
  );
  yield takeLatest(
    SAVE_IGNORE_CANDIDATE_FROM_RECOMMENDATION_REQUEST,
    saveCandidateIgnoreSaga,
  );
  yield takeLatest(
    SAVE_CANDIDATE_REJECT_STATUS_REQUEST,
    candidateJobRejectedSaga,
  );
  yield takeLatest(
    SAVE_CANDIDATE_JOB_APPLICATION_STATUS_REQUEST,
    candidateJobApplicationStatusSaga,
  );
  yield takeLatest(
    SCHEDULE_CANDIDATE_INTERVIEW_REQUEST,
    scheduleCandidateInterviewSaga,
  );
}
